import { LotameClient } from "../../../lotame/LotameClient";
import { addPostalCodeDeclaredBehavior } from "../addPostalCodeDeclaredBehavior";
import { getOttChannel, getDataLayerProperties } from "../../DatalayerUtils";

export const sendBehaviorsOnLoad = (
  planName: string,
  discountName: string,
  lotameClient: LotameClient,
  postalCode: string | undefined,
): void => {
  const { show, dist, content, user, device } = getDataLayerProperties();

  let fsa = device?.geo?.fsa ?? "";
  const url = window.location.href;
  const channel = getOttChannel(dist);
  const subject = show?.subjects?.principal ?? "";
  const genre = show?.genres?.principal ?? "";
  const codename = show?.codeName ?? "";
  const format = show?.format ?? "";
  const season = content?.season ?? "";
  const episode = content?.episode ?? "";
  const connexion = user?.rcid !== "anonyme" ? "login" : "logout";
  const audience = show?.audience?.principal ?? "";

  const consolidatedBehavior = `Ac=Load|Ch=${channel}|SubP=${subject}|GenP=${genre}|CE=${codename}|For=${format}|Sea=${season}|Ep=${episode}|Conn=${connexion}|Forf=${planName}|Dis=${discountName}|Aud=${audience}|`;

  let isolatedBehaviors = [
    `Forf=${planName}`,
    `FSA=${fsa}`,
    `Ch=${channel}`,
    `SubP=${subject}`,
    `GenP=${genre}`,
    `CE=${codename}`,
    `For=${format}`,
    `Aud=${audience}`,
  ];
  isolatedBehaviors = removeEmptyBehaviors(isolatedBehaviors);

  // noinspection SpellCheckingInspection
  const actionPayload = [consolidatedBehavior, "Ac=Load", ...isolatedBehaviors];
  const domainPayload = ["URL=" + url];
  const geoPlayload = [] as string[];

  if (postalCode) {
    geoPlayload.push(`Postal Code : ${postalCode}`);
    fsa = postalCode.substring(0, 3);
  }

  if (fsa) {
    geoPlayload.push(`fsa : ${fsa}`);
  }
  addPostalCodeDeclaredBehavior(actionPayload);

  lotameClient.callLotameApiCollect({
    behaviors: {
      act: actionPayload,
      dmn: domainPayload,
      geo: geoPlayload,
    },
  });
};

function removeEmptyBehaviors(isolatedBehaviors: string[]): string[] {
  for (let i = 0; i < isolatedBehaviors.length; i++) {
    const behavior = isolatedBehaviors[i];
    const value = behavior.split("=")[1];

    if (value === "") {
      isolatedBehaviors.splice(i, 1);
      i--;
    }
  }

  return isolatedBehaviors;
}
